import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useAuthDialog } from "@/components/AuthDialog";
import { useI18n } from "@/contexts/I18nContext";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { Button } from "@/components/ui/button";
import { Bell, BellOff, Loader2 } from "lucide-react";

export default function PushBell() {
  const { user } = useAuth();
  const { open: openAuth } = useAuthDialog();
  const { t } = useI18n();
  const { supported, permission, subscribed, busy, hint, subscribe, unsubscribe } = usePushNotifications();

  if (!supported) return null;
  const denied = permission === "denied";
  const authed = !!(user && user.id);
  // Only disable when the user IS authed AND the browser denied permission.
  // Logged-out users should still be able to click → open the auth dialog.
  const blocked = authed && denied;

  const onClick = () => {
    if (!authed) return openAuth("login");
    if (subscribed) return unsubscribe();
    return subscribe();
  };

  const title = blocked
    ? "Notifications blocked in browser settings"
    : subscribed
      ? "Push notifications enabled — click to disable"
      : authed
        ? "Enable push notifications for alerts"
        : "Sign in to enable push notifications";

  return (
    <Button
      data-testid="push-bell-btn"
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={busy || blocked}
      title={hint || title}
      aria-label={title}
      className={`pill border-[color:var(--ink-2)]/20 ${subscribed ? "bg-[color:var(--coral)]/10 text-[color:var(--coral)] border-[color:var(--coral)]/30" : ""}`}
    >
      {busy
        ? <Loader2 className="w-4 h-4 animate-spin" />
        : subscribed
          ? <Bell className="w-4 h-4" />
          : <BellOff className="w-4 h-4" />}
      <span className="hidden sm:inline ml-1.5 text-xs font-semibold">
        {subscribed ? t("push_alerts_on") : t("push_alerts")}
      </span>
    </Button>
  );
}
